import { faAngleRight, faTimes } from '@fortawesome/pro-regular-svg-icons'
import { Button, FeatureTooltip } from '@karnov/kui-react'

import { useCallback } from 'react'

import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useTranslation } from 'services/i18n'
import { useIsPanelOpen, useTogglePanel } from 'stores/usePanelsStateStore'
import { cn } from 'utils/cn'

import type { FC } from 'react'

export const ConversationMenuPanelToggle: FC = () => {
  const { t } = useTranslation()

  const triggerEvent = useTriggerEvent()

  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')
  const togglePanel = useTogglePanel()

  const handleConversationMenuPanelClick = useCallback(() => {
    togglePanel('conversations_menu')
    triggerEvent({
      name: isConversationMenuPanelOpen
        ? 'kai_sidepanel_closed'
        : 'kai_sidepanel_opened',
    })
  }, [
    isConversationMenuPanelOpen,
    togglePanel,
    triggerEvent,
  ])

  return (
    <div className="mb-1 hidden w-full items-center justify-between lg:flex">
      {isConversationMenuPanelOpen && (
        <div className="pl-2 font-medium text-default">
          {t('conversation_history.panel_header')}
        </div>
      )}
      <div
        className={cn('flex', {
          'w-[80px] justify-center': !isConversationMenuPanelOpen,
          'w-full justify-end': isConversationMenuPanelOpen,
        })}
      >
        <div className="hidden lg:flex">
          <FeatureTooltip
            content={
              isConversationMenuPanelOpen
                ? t('conversation_history.close_conversation_sidepanel')
                : t('conversation_history.open_conversation_sidepanel')
            }
            side="right"
          >
            <Button
              aria-label={
                isConversationMenuPanelOpen
                  ? t('conversation_history.close_conversation_sidepanel')
                  : t('conversation_history.open_conversation_sidepanel')
              }
              icon={isConversationMenuPanelOpen ? faTimes : faAngleRight}
              onClick={handleConversationMenuPanelClick}
              variant="plain"
              isSmall={isConversationMenuPanelOpen}
            />
          </FeatureTooltip>
        </div>
      </div>
    </div>
  )
}
